import { LoadMessage } from '../../common/load-message/LoadMessage';

/**
 * The component that is displayed during the authentication flow.
 */
export function LoadMessageLogin(): JSX.Element | null {
  return <LoadMessage keyMessage="Authenticating" showSpinner={false}></LoadMessage>;
}
